import { render, staticRenderFns } from "./switchGroup.vue?vue&type=template&id=34bbc9da&scoped=true"
import script from "./switchGroup.vue?vue&type=script&lang=js"
export * from "./switchGroup.vue?vue&type=script&lang=js"
import style0 from "./switchGroup.vue?vue&type=style&index=0&id=34bbc9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bbc9da",
  null
  
)

export default component.exports